export default __webpack_public_path__ + "img/default-product-image.07dc8113324a1e311b8582906a144964.png";